<div class="modal-backdrop fixed inset-0 z-150 flex items-center justify-center p-4">
  <div class="modal-content w-full max-w-md rounded-2xl overflow-hidden" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-white/10">
      <h2 class="text-xl font-semibold text-text-primary">{{ title }}</h2>
      <button type="button" class="p-2 rounded-xl text-text-muted hover:text-text-primary hover:bg-white/10 transition-all" (click)="close()">
        <span class="material-icons text-xl">close</span>
      </button>
    </div>

    <!-- Content -->
    <div class="p-6">
      <div class="flex items-start gap-4">
        <div class="shrink-0 w-12 h-12 rounded-full bg-red-500/20 flex items-center justify-center">
          <span class="material-icons text-red-400 text-2xl">warning</span>
        </div>
        <div class="flex-1">
          <p class="text-text-primary wrap-anywhere text-base leading-relaxed">{{ message }}</p>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex items-center justify-end gap-3 mt-8 pt-6 border-t border-white/10">
        <button type="button" class="btn-secondary px-5 py-2.5 text-sm" (click)="close()">{{ cancelText }}</button>
        <button type="button" class="btn-danger px-5 py-2.5 text-sm" (click)="confirm()">
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
</div>
